import React from 'react';
import styled from 'styled-components';
import {Eyebrow, Typography as Text, VerticalSpacer, RichTextSpan} from '..';
import {AccentColorOptions, useBreakpointDown} from 'epic-ue-theme';
import {AnimateOnViewWrap} from '../../wraps';
import Grid from '@material-ui/core/Grid';
import {ImageProps} from '../images';
import {Button} from '../buttons';
import {CmsButtonProps} from '../buttons';
import {GridContainer} from '../grid';
import {MultiCardProps} from '../../layout/multicard/MultiCard';

const Styled = styled.div`
    svg {
        font-size: 7.3em;
        ${(p) => p.theme.breakpoints.down('sm')} {
            font-size: 5.7em;
        }
    }
    .paragraph {
        letter-spacing: 0.2px;
    }

    .heading {
        font-size: 32px;
        font-weight: 400;
    }

    .description {
        font-size: 20px;
        line-height: 36px;
    }

    .mui-paper::before {
        background: #000;
    }

    .image-card .eyebrow-wrapper .heading.h4 {
        font-size: 26px;
    }

    .multicard-grid-container.ue-grid-container {
        padding-left: 0px;
    }
`;

export interface TextHeadingProps {
    heading?: string;
    eyebrow?: string;
    image?: ImageProps;
    multiCard?: MultiCardProps;
    description?: string;
    accentColor?: AccentColorOptions;
    button?: CmsButtonProps;
    stepNumber?: string | number;
}

export const TextHeading = (props: TextHeadingProps): JSX.Element => {
    const {heading, eyebrow, accentColor = 'sky', description, button = {}} = props;

    const isSm = useBreakpointDown('sm');

    return (
        <Styled className="ue-text-heading">
            <GridContainer>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="flex-end"
                    spacing={isSm ? 0 : 8}
                >
                    <Grid item xs={12} md={7} lg={9}>
                        <VerticalSpacer variant="custom" spacing={0} downSmSpacing={4} />
                        <AnimateOnViewWrap translateY={30}>
                            {eyebrow && (
                                <div className="eyebrow-container">
                                    <Eyebrow text={eyebrow} />
                                    <VerticalSpacer
                                        variant="custom"
                                        spacing={3}
                                        downSmSpacing={2}
                                    />
                                </div>
                            )}
                            {heading && (
                                <div className="heading">
                                    <Text variant="h2">{heading}</Text>
                                    <VerticalSpacer
                                        variant="custom"
                                        spacing={2}
                                        downSmSpacing={1}
                                    />
                                </div>
                            )}
                            {description && (
                                <div className="description">
                                    <RichTextSpan richText={description} />
                                </div>
                            )}
                            {button && button.label && (
                                <>
                                    <VerticalSpacer
                                        variant="custom"
                                        spacing={3}
                                        downSmSpacing={2}
                                    />
                                    <Button
                                        type={button.type}
                                        href={button.href}
                                        color={accentColor}
                                    >
                                        {button.label}
                                    </Button>
                                </>
                            )}
                        </AnimateOnViewWrap>
                    </Grid>
                    <Grid item md={5} lg={3}></Grid>
                </Grid>
            </GridContainer>
        </Styled>
    );
};
